import {createAsyncThunk} from '@reduxjs/toolkit'
import {API_CONFIG} from '../app/api-config';
import {ApiResultOfJsonTemplate, CloneTemplatesUsingPOSTRequest, GetTemplateListUsingGETRequest, JsonTemplate, ReplaceTemplateFileUsingPOSTRequest, TemplateControllerApi} from '../generated-api';

const templatesApi = new TemplateControllerApi(API_CONFIG);

export const fetchTemplates = createAsyncThunk('templates/list', async (filter: GetTemplateListUsingGETRequest, thunkApi) => {
    return {...await templatesApi.getTemplateListUsingGET(filter), filter};
});

export const fetchTemplate = createAsyncThunk('template/fetch', async (templateId: number): Promise<ApiResultOfJsonTemplate> => {
    return await templatesApi.getTemplateUsingGET({templateId});
});

export const saveTemplate = createAsyncThunk('template/save', async (template: JsonTemplate) => {
    return await templatesApi.saveTemplateUsingPOST({json: template});
});

export const cloneTemplates = createAsyncThunk('templates/clone', async (params: CloneTemplatesUsingPOSTRequest) => {
    return await templatesApi.cloneTemplatesUsingPOST(params);
});

export const previewTemplate = createAsyncThunk('template/preview', async (template: JsonTemplate) => {
    return await templatesApi.previewTemplateUsingPOST({json: template});
});

export const replaceTemplateFile = createAsyncThunk('template/file', async (params: ReplaceTemplateFileUsingPOSTRequest) => {
    return await templatesApi.replaceTemplateFileUsingPOST(params);
});
